import React from 'react';

import TextAreaField from '../../../../Forms/Input/TextAreaField';

import SvgIcon from '../../../../SvgIcon/SvgIcon';

import { useQuotation } from '../../../../../hooks/sale/useQuotation';

const QuotationNotesSection: React.FC = () => {
  const { form, updateField } = useQuotation();

  // =====================================================
  // 🔹 No Active Quotation
  // =====================================================

  if (!form?.id) {
    return null;
  }

  return (
    <div className="flex flex-col gap-5">
      {/* ===================================================== */}
      {/* 🔹 Header */}
      {/* ===================================================== */}

      <div
        className="
        flex
        items-start
        gap-3

        sm:items-center
      "
      >
        <div
          className="
          flex
          h-11
          w-11

          shrink-0

          items-center
          justify-center

          rounded-xl

          border
          border-primary/15

          bg-primary/10

          text-primary
        "
        >
          <SvgIcon name="file" />
        </div>

        <div>
          <h3
            className="
            text-base
            font-semibold

            text-black

            dark:text-white
          "
          >
            Observaciones
          </h3>

          <p
            className="
            mt-1

            text-sm

            text-body
          "
          >
            Agrega notas o condiciones para esta cotización.
          </p>
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Content */}
      {/* ===================================================== */}

      <TextAreaField
        label="Notas"
        name="notes"
        value={form?.notes || ''}
        onChange={(e) => updateField('notes', e.target.value)}
        rows={4}
        iconKey="file"
      />
    </div>
  );
};

export default QuotationNotesSection;
